import { updatePreferences } from 'store/Preferences/actions';
import { buildSeenReleases } from './helpers';
import { selectWhatsNewSeenReleases } from './selectors';

// eslint-disable-next-line import/prefer-default-export
export function markWhatsNewReleasesSeen (versionIds, seenVersionIds) {
  return async (dispatch, getState) => {
    const storedSeenReleases = selectWhatsNewSeenReleases(getState());
    const seenReleases = buildSeenReleases(versionIds, storedSeenReleases).map((release) => (
      seenVersionIds.includes(release.version) ? { ...release, seen: true } : release
    ));

    return dispatch(updatePreferences({ whats_new: { seen_releases: seenReleases } }));
  };
}
